export default __webpack_public_path__ + "static/media/google.7be3af0b.png";